<template>
  <button-line
    :items="items"
    v-bind="$attrs"
  ></button-line>
</template>

<script>
import ButtonLine from '../../components/Parts/ButtonLine';

/**
 * Component EncounterButtonLine.vue
 *
 * @module EncounterButtonLine
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.4] app/src/APP_DASHBOARD/templates/views/Encounter/EncounterButtonLine.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'EncounterButtonLine',
  components: {
    ButtonLine,
  },
  props: {
    isMedicationDSSAvailable: {
      type: Boolean,
      default: () => false,
    },
    is6MWTAvailable: {
      type: Boolean,
      default: () => false,
    }
  },
  computed: {
    items() {
      return [
        {
          label: this.$ucfirst(this.$t('encounter.vitalSigns', {catalog: 'app_dashboard', language: 'en'})),
          route: { name: 'PatientEncounterVitalSigns' },
        },
        {
          label: this.$ucfirst(this.$t('walkingTest.title', {catalog: 'app_dashboard', language: 'en'})),
          route: { name: 'PatientEncounterWalkingTest' },
          disabled: !this.is6MWTAvailable
        },
        {
          label: this.$ucfirst(this.$t('encounter.clinicalAssessment', {catalog: 'app_dashboard', language: 'en'})),
          route: { name: 'PatientEncounterClinicalAssessment' },
        },
        {
          label: this.$ucfirst(this.$t('encounter.medicationDSS', {catalog: 'app_dashboard', language: 'en'})),
          route: { name: 'PatientEncounterMedicationDSS' },
          disabled: !this.isMedicationDSSAvailable,
        },
      ];
    },
  },
};
</script>
